import { render } from "./roulette.vue?vue&type=template&id=0f3e1dbe"
import script from "./roulette.vue?vue&type=script&lang=js"
export * from "./roulette.vue?vue&type=script&lang=js"

import "./roulette.vue?vue&type=style&index=0&id=0f3e1dbe&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__